import toIcon from '../toIcon';
import svg from './icon.svg'; // 5

const AmazonIcon = toIcon(svg, {
  margin: '0 -0.03em',
});

export default AmazonIcon;
